module.exports = __webpack_public_path__ + "static/img/yx8.d22b13d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx8.jpg
// module id = i+FC
// module chunks = 1